module.exports = __webpack_public_path__ + "img/12_91.9fa214ff.png";